export const DEFAULT_RTSP_PORT = 554;

export const GREY_RTSP_FIELDS = ["grey_rtsp_link", "grey_ip", "rtsp_port"];

export const normalizeRtspPort = (port) => {
  if (port === null || port === undefined || String(port).trim() === "") {
    return DEFAULT_RTSP_PORT;
  }

  return port;
};

export const prepareGreyRtspPayload = (form, isModelRtspCamera) => {
  const camera = { ...form };

  if (isModelRtspCamera) {
    camera.rtsp_port = normalizeRtspPort(camera.rtsp_port);
    delete camera.grey_rtsp_link;
  } else {
    delete camera.grey_ip;
    delete camera.rtsp_port;
  }

  return camera;
};
